import React from 'react';
import { Grid, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import UseCurrency from '@shared/hooks/UseCurrency';
import { titles } from './messages';
import RenderButton from './RenderButton';

import MochilaIcon from '@shared/assets/baggages/MochilaIcon';
import CarryonIcon from '@shared/assets/baggages/CarryonIcon';
import BodegaIcon from '@shared/assets/baggages/BodegaIcon';

import { sxStyle, StyledButton } from './styles';

const BaggageModal = ({
  closeModal,
  differenceBaggage,
  selectedOption,
  selectedFlightBaggage,
}) => {
  const { currency } = UseCurrency();

  const {
    with_hold_baggage,
    with_hand_baggage,
    with_only_hold_baggage,
    validate,
  } = differenceBaggage;

  const handleSelect = option => {
    selectedOption(option);
  };

  const mochilaSize = { xs: 22, sm: 26, md: 32 };
  const carryonSize = { xs: 28, sm: 32, md: 38 };
  const bodegaSize = { xs: 34, sm: 38, md: 44 };

  // ✅ ARRAY DINÁMICO

  const options = [
    {
      label: 'Equipaje de mano',
      data: with_hand_baggage,
      icons: [
        { Component: MochilaIcon, size: mochilaSize },
        { Component: CarryonIcon, size: carryonSize },
      ],
    },
    {
      label: 'Equipaje de bodega',
      data: with_only_hold_baggage,
      icons: [
        { Component: MochilaIcon, size: mochilaSize },
        { Component: BodegaIcon, size: carryonSize },
      ],
    },
    {
      label: 'Todos los equipajes',
      data: with_hold_baggage,
      icons: [
        { Component: MochilaIcon, size: mochilaSize },
        { Component: CarryonIcon, size: carryonSize },
        { Component: BodegaIcon, size: bodegaSize },
      ],
    },
  ].filter(opt => opt.data);

  const baggageMap = {
    1: 'objeto personal',
    3: 'equipaje de mano',
    7: 'equipaje de bodega',
  };

  const value =
    (selectedFlightBaggage?.backpack_baggage ?? 0) +
    (selectedFlightBaggage?.hand_baggage ?? 0) * 2 +
    (selectedFlightBaggage?.baggage_hold ?? 0) * 4;

  const baggageText = baggageMap[value] || '';

  return (
    <Grid
      container
      direction="column"
      spacing={2}
      id="modal-baggage"
      sx={sxStyle.root}
    >
      {/* TEXTOS */}
      <Grid item xs={12} sx={{ position: 'relative', pr: 2 }}>
        <CloseIcon
          onClick={closeModal}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
            cursor: 'pointer',
            fontSize: '22px',
          }}
        />

        <Typography
          sx={{
            ...sxStyle.firstText,
            paddingRight: '40px',
            paddingLeft: '40px',
          }}
        >
          {titles[0]}
        </Typography>

        <Typography sx={sxStyle.secondaryText}>
          Tené en cuenta que comprando de forma anticipada podés ahorrar hasta
          un 50% en el costo de tus valijas.
        </Typography>
      </Grid>

      <Grid container spacing={4} justifyContent="center">
        {options.map((opt, idx) => (
          <Grid
            item
            key={`${opt.label}-${+idx}`}
            xs="auto"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexGrow: 0,
            }}
          >
            <RenderButton
              label={opt.label}
              data={opt.data}
              icons={opt.icons}
              selectedOption={handleSelect}
            />
          </Grid>
        ))}
      </Grid>

      <Grid container sx={{ mt: '25px', mb: 1 }}>
        <Grid
          item
          xs={12}
          sx={{ pt: 0, display: 'flex', justifyContent: 'flex-end', px: 2 }}
        >
          <Typography
            sx={{
              pl: '16px',
              fontSize: { xs: '14px', md: '18px' },
              alignSelf: 'center',
              pr: 4,
            }}
          >
            Continuar con {baggageText} por:{' '}
            <strong
              style={{
                color: '#000',
                whiteSpace: 'nowrap',
              }}
            >
              {currency(validate?.difference?.total ?? 0)}
            </strong>
          </Typography>

          <StyledButton
            variant="contained"
            onClick={() => selectedOption(validate)}
          >
            Continuar
          </StyledButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BaggageModal;
